module.exports = __webpack_public_path__ + "static/month-modal-89fea681d51aec3be85192945b157013.png";